"use client"
import React, { useState } from 'react';

const FaqsBlogs = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  // console.log(isOpen)

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
     
      {/* <h1 id="how-hrm-contributes-to-business-success">Hello</h1> */}

      <dl className="toggle border-b border-gray-300 mb-1">
        <dt
          onClick={toggleAnswer}
          className="flex justify-between items-center p-2 cursor-pointer transition"
        >
          <a className="text-lg font-semibold text-gray-800 hover:text-gray-800 ">{question}</a>
          <a className="mean-expand text-gray-800" href="#" style={{ fontSize: 24 }}>
            {isOpen ? "-" : "+"}
          </a>
        </dt>
        {isOpen && (
          <dd className="p-2 text-gray-700 ">
            <p className='!pb-0'>{answer}</p>
          </dd>
        )}
      </dl>


    </>
  );
};

export default FaqsBlogs;
